module.exports = __webpack_public_path__ + "static/media/RaisingChildren_ios_1_preview.36b1e560.jpg";